<template>
  <b-modal
    ref="modal"
    title="Zmiana statusu online"
    centered
  >
    Czy zmienić status online?

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <div>
          <b-button variant="secondary" @click="hide()">
            Anuluj
          </b-button>
        </div>
        <div>
          <b-button
            variant="primary"
            :disabled="form.processing"
            @click="setOnline"
          >
            Zmień
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      schedule: null,
      form: this.$inertia.form({
        isOnline: false,
      }),
    }
  },
  methods: {
    setOnline() {
      if (!this.schedule) return;
      this.form.isOnline = !this.schedule.is_online
      this.form.post(this.route('schedules.online', this.schedule.id), {
        replace: true,
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => this.hide()
      })
    },
    show(schedule) {
      this.schedule = schedule
      this.$refs.modal.show()
    },
    hide() {
      this.schedule = null
      this.$refs.modal.hide()
    },
  },
}
</script>
